var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"music",on:{"click":_vm.switchMusic}},[_c('img',{class:{ rotate: _vm.on },attrs:{"src":require("@/assets/imgs/public/music-on.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }